import { Capacitor } from "@capacitor/core";

export type AppPlatform = "web" | "ios" | "android";

export interface PlatformServices {
  platform: AppPlatform;
  isNative: boolean;
  openDirections(address: string): void;
  call(phone: string): void;
}

const platform = Capacitor.getPlatform() as AppPlatform;

export const platformServices: PlatformServices = {
  platform,
  isNative: Capacitor.isNativePlatform(),
  openDirections(address) {
    const query = encodeURIComponent(address);
    window.location.href = platform === "ios" ? `maps://?q=${query}` : `https://maps.google.com/?q=${query}`;
  },
  call(phone) {
    window.location.href = `tel:${phone}`;
  },
};
